(function () {
  if (window.__PS_ANNOUNCEMENT_SLIDER_BOOTED__) return;
  window.__PS_ANNOUNCEMENT_SLIDER_BOOTED__ = true;

  function initAnnouncementSlider() {
    const root = document.querySelector('[data-ps-annbar]');
    if (!root) return;

    const slides = Array.from(root.querySelectorAll('[data-ps-annbar-slide]'));
    if (slides.length === 0) return;

    const prevBtn = root.querySelector('[data-ps-annbar-prev]');
    const nextBtn = root.querySelector('[data-ps-annbar-next]');
    const dotsWrap = root.querySelector('[data-ps-annbar-dots]');

    let index = 0;
    let timer = null;

    const autoplayEnabled = root.getAttribute('data-autoplay') === 'true';
    const interval = Math.max(1500, parseInt(root.getAttribute('data-interval') || '5000', 10));
    const dotsEnabled = root.getAttribute('data-dots') === 'true';

    function applyColors(slideEl) {
      const bg = slideEl.getAttribute('data-bg');
      const text = slideEl.getAttribute('data-text');
      if (bg) root.style.setProperty('--ps-ann-bg', bg);
      if (text) root.style.setProperty('--ps-ann-text', text);
    }

    function render(i, options = {}) {
      const focus = options.focus === true;
      index = (i + slides.length) % slides.length;

      slides.forEach((el, idx) => {
        if (idx === index) {
          el.hidden = false;
          applyColors(el);
        } else {
          el.hidden = true;
        }
      });

      if (dotsWrap) {
        const dots = Array.from(dotsWrap.querySelectorAll('button.ps-annbar__dot'));
        dots.forEach((dot, idx) => dot.setAttribute('aria-current', idx === index ? 'true' : 'false'));
      }

      if (focus) {
        const focusTarget = slides[index].querySelector('a,button,[tabindex]');
        if (focusTarget && focusTarget.focus) focusTarget.focus();
      }
    }

    function stop() {
      if (timer) {
        clearInterval(timer);
        timer = null;
      }
    }

    function start() {
      stop();
      if (!autoplayEnabled || slides.length <= 1) return;
      timer = setInterval(() => render(index + 1), interval);
    }

    function buildDots() {
      if (!dotsWrap || !dotsEnabled || slides.length <= 1) return;
      dotsWrap.innerHTML = '';

      slides.forEach((_, i) => {
        const dotButton = document.createElement('button');
        dotButton.type = 'button';
        dotButton.className = 'ps-annbar__dot';
        dotButton.setAttribute('aria-label', `Go to slide ${i + 1}`);
        dotButton.setAttribute('aria-current', i === 0 ? 'true' : 'false');
        dotButton.addEventListener('click', () => {
          render(i);
          start();
        });
        dotsWrap.appendChild(dotButton);
      });
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', () => {
        render(index - 1);
        start();
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', () => {
        render(index + 1);
        start();
      });
    }

    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', start);
    root.addEventListener('focusin', stop);
    root.addEventListener('focusout', start);

    buildDots();
    render(0);
    start();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAnnouncementSlider);
  } else {
    initAnnouncementSlider();
  }

  document.addEventListener('shopify:section:load', initAnnouncementSlider);
})();
